import React, { useEffect, useState } from 'react';
import { Row, Col, Modal, Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import Loader from '../../Loader';
import Message from '../../Message';
import { deleteAddress } from '../../../actions/addressActions';
import { addressDeleteReset } from '../../../reducers/addressReducers';
import { FaTrash } from 'react-icons/fa';
import { COLORS } from '../../../constants/colors';

function DeleteAddressModal({ show, onHide, addressData, dispatch }) {
    // Color constants to match with ProfileDetails.js
    const plum = COLORS.PLUM;
    const sageGreen = COLORS.SAGE_GREEN;
    const warmConcrete = COLORS.WARM_CONCRETE;
    const errorColor = COLORS.ERROR;
    
    // Store address data locally to prevent it from being lost on component refresh
    const [localAddressData, setLocalAddressData] = useState(addressData);
    
    // Update local state when props change
    useEffect(() => {
        if (addressData && addressData._id) {
            setLocalAddressData(addressData);
        }
    }, [addressData]);


    const {
        addressReducers: { addressDeleteError, addressDeleteLoading, addressDeleteSuccess }
    } = useSelector((state) => state);

    useEffect(() => {
        if (addressDeleteSuccess) {
            dispatch(addressDeleteReset());
            onHide();
        }
    }, [dispatch, addressDeleteSuccess, onHide]);

    const deleteHandler = () => {
        if (!localAddressData || !localAddressData._id) {
            console.error('No address ID provided for deletion, addressData:', localAddressData);
            return;
        }
        
        const addressId = localAddressData._id;
        dispatch(deleteAddress(addressId));
    };

    // Safely display address name with fallback
    const addressName = localAddressData?.name || 'this address';
    const hasValidId = !!(localAddressData && localAddressData._id);

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton className='border-0'></Modal.Header>
            <Col className='d-flex justify-content-center mb-3'>
                <h4 style={{ color: plum }}>Delete Address</h4>
            </Col>
            <Modal.Body className="text-center">
                {addressDeleteError && <Message variant='danger'>{addressDeleteError}</Message>}
                {addressDeleteLoading && <Loader />}
                
                {!hasValidId ? (
                    <Message variant='warning'>
                        Unable to delete: Invalid address data
                    </Message>
                ) : (
                    <>
                        <p className="mb-4">
                            Delete address 
                            <span className="fw-bold"> "{addressName}"</span>?
                        </p>
                        <p className="small text-muted mb-4">
                            This action cannot be undone.
                        </p>
                        
                        <Row className='d-flex justify-content-center mt-3'>
                            <Col xs={6} md={5} className='d-flex justify-content-end pe-2'>
                                <Button 
                                    style={{ backgroundColor: sageGreen, borderColor: warmConcrete }}
                                    onClick={onHide}
                                    className='my-3 w-50'
                                >
                                    Cancel
                                </Button>
                            </Col>
                            <Col xs={6} md={5} className='d-flex justify-content-start ps-2'>
                                <Button 
                                    style={{ backgroundColor: errorColor, borderColor: warmConcrete }}
                                    onClick={deleteHandler}
                                    className='my-3 w-50'
                                    disabled={!hasValidId}
                                >
                                    <FaTrash size={14} className="me-2" /> 
                                </Button>
                            </Col>
                        </Row>
                    </>
                )}
            </Modal.Body>
        </Modal>
    );
}

export default DeleteAddressModal;